import React, { ReactNode } from 'react';
import { useField } from 'react-final-form';
import { Input, InputTypeMap } from '../../../../ui/Input';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { FormErrorField } from '../FormErrorField';
import { HintTooltip } from '../../../../ui/HintTooltip';
import { InputWrapper } from './styled';
import {
  IconComponent,
  InputMode,
  InputType
} from '../../../../ui/Input/types';

interface FormTextInputProps {
  type?: InputType;
  maxLength?: string;
  name: string;
  placeholder: string | ReactNode;
  hasErrorField?: boolean;
  isFloat?: boolean;
  inputMode?: InputMode;
  isEnabledAutoSelectionRange?: boolean;
  format?: (value: string) => string;
  disabled?: boolean;
  icon?: IconComponent;
  onClick?: () => void;
  showPhoneMask?: boolean;
  hint?: string;
}

export const FormTextInput: React.FC<FormTextInputProps> = ({
  type = InputTypeMap.text,
  maxLength,
  name,
  placeholder,
  hasErrorField,
  isFloat,
  inputMode,
  isEnabledAutoSelectionRange,
  disabled = false,
  icon,
  format,
  onClick,
  showPhoneMask = false,
  hint
}) => {
  const { input, meta } = useField(name, {
    subscription: { value: true, error: true, submitFailed: true }
  });

  return (
    <div>
      <InputWrapper isError={meta.submitFailed && meta.error}>
        <Input
          type={type}
          name={name}
          maxLength={maxLength}
          placeholder={placeholder}
          value={input.value}
          formValues={FORM_VALUES}
          isFloat={isFloat}
          format={format}
          inputMode={inputMode}
          isEnabledAutoSelectionRange={isEnabledAutoSelectionRange}
          disabled={disabled}
          icon={icon}
          onClick={onClick}
          showPhoneMask={showPhoneMask}
          endAdornment={
            hint ? (
              <HintTooltip text={hint} cypress={`${name}-hint`} />
            ) : undefined
          }
        />
      </InputWrapper>
      {hasErrorField && (
        <FormErrorField field={name} cypress={`${name}-field-error`} />
      )}
    </div>
  );
};
